const isExisty = function(value) {
  return value !== null && value !== undefined;
};

const isEmpty = function(value) {
  return value === '';
};

var validations = {
  isDefaultRequiredValue(value) {
    return value === undefined || value === '';
  },
  isExisty(value) {
    return isExisty(value);
  },
  isExistyAndNotEmptyString(value) {
    return isExisty(value) && !isEmpty(value);
  },
  matchRegexp(value, regexp) {
    return !isExisty(value) || isEmpty(value) || regexp.test(value);
  },
  isUndefined(value) {
    return value === undefined;
  },
  isEmptyString(value) {
    return isEmpty(value);
  },
  isNotEmptyString(value) {
    return !isEmpty(value);
  },
  isEmail(value) {
    return validations.matchRegexp(
      value,
      /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i,
    );
  },
  isUrl(value) {
    return validations.matchRegexp(
      value,
      /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
    );
  },
  isTrue(value) {
    return value === true;
  },
  isFalse(value) {
    return value === false;
  },
  isNumeric(value) {
    if (typeof value === 'number') {
      return true;
    }
    return validations.matchRegexp(value, /^[-+]?(?:\d*[.])?\d+$/);
  },
  isAlpha(value) {
    return validations.matchRegexp(value, /^[A-Z]+$/i);
  },
  isAlphanumeric(value) {
    return validations.matchRegexp(value, /^[0-9A-Z]+$/i);
  },
  isInt(value) {
    return validations.matchRegexp(value, /^(?:[-+]?(?:0|[1-9]\d*))$/);
  },
  isIntPositive(value) {
    return validations.matchRegexp(value, /^(?:\+?[1-9]\d*)$/);
  },
  isFloat(value) {
    return validations.matchRegexp(
      value,
      /^(?:[-+]?(?:\d+))?(?:\.\d*)?(?:[eE][\+\-]?(?:\d+))?$/,
    );
  },
  isDate(value) {
    let isValid = false;
    let testDate;
    try {
      testDate = new Date(value);
      if (!isNaN(testDate)) {
        isValid = true;
      } else {
        isValid = false;
      }
    } catch (e) {
      isValid = false;
    }
    return isValid;
  },
  isMoneyDecimal(value) {
    // this is more leannient accepting commas and $ signs
    // accepts $1,234.23 - strips any non numeric character not a dot.  also accepts '' as zero
    let testValue;
    if (typeof value === 'string') {
      testValue = Number(value.replace(/[^0-9\.]+/g, ''));
    } else {
      testValue = Number(value);
    }
    return !isNaN(testValue);
  },
  isJSON(value) {
    try {
      JSON.parse(value);
    } catch (e) {
      return false;
    }
    return true;
  },
  // ^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}Z$
  // var regEx = /^\d{4}-\d{2}-\d{2}$/;
  isWords(value) {
    return validations.matchRegexp(value, /^[A-Z\s]+$/i);
  },
  isSpecialWords(value) {
    return validations.matchRegexp(value, /^[A-Z\s\u00C0-\u017F]+$/i);
  },
  isLength(value, length) {
    return !isExisty(value) || isEmpty(value) || value.length === length;
  },
  equals(value, eql) {
    return !isExisty(value) || isEmpty(value) || value == eql;
  },
  equalsField(value, field) {
    return value == field.getValue();
  },
  maxLength(value, length) {
    return !isExisty(value) || value.length <= length;
  },
  minLength(value, length) {
    return !isExisty(value) || isEmpty(value) || value.length >= length;
  },
  isEmailArray(value) {
    if (!value || value.length === 0) {
      return true;
    }

    return value.every(email => {
      const emailValue = typeof email === 'string' ? email : email.value;
      return validations.isEmail(emailValue);
    });
  },
};

module.exports = validations;



// WEBPACK FOOTER //
// ./src/core/validationRules.js